module.exports = __webpack_public_path__ + "img/s20.65dff29.png";